(function () {
  'use strict';

  angular.module('ringbaPortal').component('simpleSwitch', {
    bindings: {
      isRequired: '<',
      settingOption1: '<',
      settingOption1Label: '@',
      settingOption2: '<',
      settingOption2Label: '@',
      toggleValueChanged: '&',
    },
    controller: simpleSwitchController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/simple-switch/simple-switch.view.html'
  });

  function simpleSwitchController() {
    'ngInject';

    const vm = this;
    vm.setToggle = setToggle;
    vm.option1 = 'option1';
    vm.option2 = 'option2';

    function setToggle() {
      let newSettingValue;

      if (vm.selectedValue === vm.option1) {
        newSettingValue = vm.settingOption1;
      } else {
        newSettingValue = vm.settingOption2;
      }

      vm.toggleValueChanged()(newSettingValue);
    }
  }
})();
